export default __webpack_public_path__ + "static/media/ML.0ac683aa.svg";